import Axios from "axios";

// import {
//   SET_LOADING,
// } from "../mutation-types";

import { fileServerUrl,frontendBaseUrl } from "../api";
// initial state
const state = {
  fileServerUrl: fileServerUrl,
  frontendBaseUrl: frontendBaseUrl,
};

const getters = {
    getFileServerUrl(state){
        return state.fileServerUrl;
    },
    frontendBaseUrl(state){
        return state.frontendBaseUrl;
    },

};

const mutations = {
//   [SET_LOADING](state, payload) {
//     state.loading = true;
//     state.loading_color = payload.color;
//   },

};

const actions = {

};

export default {
  state,
  getters,
  actions,
  mutations,
};
